import {
  Navigate,
  useLocation,
  useOutlet,
  useNavigate,
} from "react-router-dom";

import { useAuth } from "../Hooks/useAuth";

import React from "react";
import { PopupNotificationProvider } from "Context/NotificationPopup";

export default function ProtectedLayout() {
  const { authData } = useAuth();
  const outlet = useOutlet();
  const location = useLocation();

  if (!authData || authData?.userType !== "admin") {
    return (
      <PopupNotificationProvider>
        <Navigate to="/login" state={{ from: location.pathname }} replace />
      </PopupNotificationProvider>
    );
  }

  return <PopupNotificationProvider>{outlet}</PopupNotificationProvider>;
}
